import { render } from "./smallChart.vue?vue&type=template&id=c76cb4c6"
import script from "./smallChart.vue?vue&type=script&lang=js"
export * from "./smallChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__